import * as types from './constants';

export function loginFailure () {
  return {
    type: types.LOGIN_FAILURE,
    isError: true
  };
}

export function loginSuccess () {
  return {
    type: types.LOGIN_SUCCESS
  };
}

export function logout () {
  return {
    type: types.LOGOUT
  };
}



/** WEBPACK FOOTER **
 ** ./src/interactive-solutions/authentication/actions.js
 **/